function getHostname() {
  return window.location.hostname;
}

export default getHostname;
